module.exports = __webpack_public_path__ + "img/third.2eba90a4.jpg";